// extracted by mini-css-extract-plugin
export default {"book":"RecipeBookClosed_book__QV73e","abv":"RecipeBookClosed_abv__XLRcX"};